import { createSelector } from "redux-starter-kit";
import { isEmpty } from "lodash";

export default createSelector(
  ["signup.exchangePlaidSuccess"],
  payload => !isEmpty(payload)
);
